class AnimatedFitCheck {
    constructor(container) {
        this.container = container;
        this.currentScreen = 1;
        this.currentQuestion = 1;
        this.totalQuestions = 7;
        this.scores = [];
        this.timerInterval = null;
        this.isProcessingAnswer = false;
        this.lastFormSubmission = 0; // Track last form submission time
        this.submissionCooldown = 5000; // 5 second cooldown between submissions
        
        this.init();
    }
    
    init() {
        this.resetScores();
        this.bindEvents();
        this.initializeScreens();
        this.startScreen1Timer();
        
        
        // Initialize navigation
        this.initializeNavigation();
        
                // Debug: Log available score sections
        this.logAvailableScoreSections();
    }
    
    logAvailableScoreSections() {
        // Check if score range data is available
        const scoreRangeDataInput = this.container.querySelector('#scoreRangeData');
        if (scoreRangeDataInput) {
            try {
                const scoreRangeData = JSON.parse(scoreRangeDataInput.value);
                // Score ranges loaded successfully
            } catch (error) {

            }
        }
    }
    
    resetScores() {
        // Initialize scores array with zeros for all questions
        this.scores = new Array(this.totalQuestions).fill(0);
        this.currentQuestion = 1;
    }
  
    initializeNavigation() {
        // Create dynamic navigation indicators
        this.createNavigationIndicators();
        
        // Update navigation state
        this.updateNavigationState();
    }
    
    createNavigationIndicators() {
        // Create indicators for all questions
        const allQuestions = this.container.querySelectorAll('.question');
        allQuestions.forEach((question, index) => {
            const navIndicators = question.querySelector('#navIndicators');
            if (!navIndicators) return;
            
            // Clear existing indicators
            navIndicators.innerHTML = '';
            
            // Create indicators for all questions
            for (let i = 0; i < this.totalQuestions; i++) {
                const indicator = document.createElement('div');
                indicator.className = 'nav-indicator';
                if (i === 0) {
                    indicator.classList.add('active'); // First question is active by default
                }
                indicator.id = `navIndicator${i + 1}_${index + 1}`;
                navIndicators.appendChild(indicator);
            }
        });
    }
    
    updateNavigationState() {
        // Get the active question
        const activeQuestion = this.container.querySelector('.question.active');
        if (!activeQuestion) return;
        
        // Update current indicator position for the active question
        const navIndicators = activeQuestion.querySelector('#navIndicators');
        if (navIndicators) {
            const allIndicators = navIndicators.querySelectorAll('.nav-indicator');
            
            // Remove active class from all indicators
            allIndicators.forEach(indicator => {
                indicator.classList.remove('active');
            });
            
            // Add active class to current question indicator
            if (this.currentQuestion <= allIndicators.length) {
                allIndicators[this.currentQuestion - 1].classList.add('active');
            }
        }
        
        // Update arrow states for the active question
        const leftArrow = activeQuestion.querySelector('#navArrowLeft');
        const rightArrow = activeQuestion.querySelector('#navArrowRight');
        
        if (leftArrow) {
            // Left arrow (preview) is only enabled when not on first question
            leftArrow.disabled = this.currentQuestion === 1;
            leftArrow.classList.toggle('disabled', this.currentQuestion === 1);
        }
        
        if (rightArrow) {
            // Right arrow is enabled when there's a next question available AND current question is answered
            const hasNextQuestion = this.currentQuestion < this.totalQuestions;
            const isCurrentQuestionAnswered = this.isQuestionAnswered(this.currentQuestion);
            const shouldEnableRightArrow = hasNextQuestion && isCurrentQuestionAnswered;
            
            rightArrow.disabled = !shouldEnableRightArrow;
            rightArrow.classList.toggle('disabled', !shouldEnableRightArrow);
        }
    }
    
    initializeScreens() {
        // Ensure only screen 1 is active initially
        const screens = this.container.querySelectorAll('.fit-check-screen');
        screens.forEach(screen => {
            screen.classList.remove('active');
        });
        
        const screen1 = this.container.querySelector('.screen-1');
        if (screen1) {
            screen1.classList.add('active');
        }
        
        // Reset screens container position to show first screen
        const screensContainer = this.container.querySelector('.screens-container');
        if (screensContainer) {
            screensContainer.style.transform = 'translateX(0)';
        }
        
        // Ensure static screen is hidden initially
        const staticScreen = this.container.querySelector('.static-screen');
        if (staticScreen) {
            staticScreen.classList.remove('active');
        }
    }
    
    bindEvents() {
        // Answer options
        const answerOptions = this.container.querySelectorAll('.answer-option');
        answerOptions.forEach(option => {
        option.addEventListener('click', (e) => {
            this.handleAnswerSelection(e.target.closest('.answer-option'));
        });
        });
        
        
        // Navigation arrows - bind to all navigation arrows
        const leftArrows = this.container.querySelectorAll('#navArrowLeft');
        leftArrows.forEach(leftArrow => {
            leftArrow.addEventListener('click', () => {
                this.goToPreviousQuestion();
            });
        });
        
        const rightArrows = this.container.querySelectorAll('#navArrowRight');
        rightArrows.forEach(rightArrow => {
            rightArrow.addEventListener('click', () => {
                // Navigate to next question if available
                this.goToNextQuestion();
            });
        });
    }
  
    goToPreviousQuestion() {
        if (this.currentQuestion > 1) {
            this.showQuestion(this.currentQuestion - 1);
        }
    }
    
    goToNextQuestion() {
        if (this.currentQuestion < this.totalQuestions) {
            this.showQuestion(this.currentQuestion + 1);
        }
    }
    
    isQuestionAnswered(questionNumber) {
        // Check if the question has a valid score (answered)
        const questionIndex = questionNumber - 1;
        return this.scores[questionIndex] !== undefined && 
               this.scores[questionIndex] !== null && 
               this.scores[questionIndex] > 0;
    }
    
  
    validateAllQuestionsAnswered() {
        // Check if all questions have valid scores
        for (let i = 0; i < this.totalQuestions; i++) {
            if (this.scores[i] === undefined || this.scores[i] === null || this.scores[i] === 0) {
                return false;
            }
        }
        return true;
    }
  
    goToFirstUnansweredQuestion() {
        // Find the first question without a score
        for (let i = 0; i < this.totalQuestions; i++) {
            if (this.scores[i] === undefined || this.scores[i] === null || this.scores[i] === 0) {
                this.showQuestion(i + 1);
                break;
            }
        }
    }
    
    startScreen1Timer() {
        const timerNumber = this.container.querySelector('.timer-number');
        const timerDuration = parseInt(this.container.dataset.timerDuration) || 3;
        let countdown = timerDuration;
    
        // Update timer display
        if (timerNumber) {
            timerNumber.textContent = countdown;
            
            // Start with zoom-in animation
            timerNumber.classList.add('zoom-in');
            
            // Wait for zoom-in animation to complete before starting countdown
            setTimeout(() => {
                // Remove zoom-in class and start blinking effect
                timerNumber.classList.remove('zoom-in');
                timerNumber.classList.add('blink');
                
                // Update display to show the starting countdown value
                timerNumber.textContent = countdown - 1;
                
                // Start the countdown timer from (timerDuration - 1)
                this.startCountdown(countdown - 1, timerNumber);
            }, 1200); // Match the duration of zoom-in animation
        }
    }
    
    startCountdown(countdown, timerNumber) {
        this.timerInterval = setInterval(() => {
            countdown--;
            
            if (timerNumber) {
                timerNumber.textContent = countdown;
                
                // Add blinking effect when timer changes
                timerNumber.classList.remove('blink');
                // Force reflow to ensure animation triggers
                timerNumber.offsetHeight;
                timerNumber.classList.add('blink');
            }
    
            if (countdown <= 0) {
                clearInterval(this.timerInterval);
                // Remove the entire timer section when countdown completes
                const timerSection = this.container.querySelector('.timer-section');
                if (timerSection) {
                    timerSection.style.opacity = '0';
                }
                this.goToScreen(2);
            }
        }, 1000);
    }
    
      goToScreen(screenNumber) {
        // Clear any existing timers
        if (this.timerInterval) {
          clearInterval(this.timerInterval);
          this.timerInterval = null;
        }
    
        // Store the previous screen for animation direction
        const previousScreen = this.currentScreen;
        
        // Update current screen
        this.currentScreen = screenNumber;
    
        // Add swipe animation for screen transitions
        this.animateScreenTransition(screenNumber, previousScreen);
    
        // Handle screen-specific logic
        switch (screenNumber) {
          case 1:
            this.startScreen1Timer();
            break;
          case 2:
            // Pause on screen 2 for a few seconds before continuing to screen 3
            setTimeout(() => {
              this.goToScreen(3);
            }, 3000); // 3 second pause
            break;
          case 3:
            this.showQuestion(1);
            break;
        }
      }
    
      animateScreenTransition(screenNumber, previousScreen) {
        const screens = this.container.querySelectorAll('.fit-check-screen');
        const currentActiveScreen = this.container.querySelector('.fit-check-screen.active');
        const targetScreen = this.container.querySelector(`[data-screen="${screenNumber}"]`);
        const screensContainer = this.container.querySelector('.screens-container');
        const staticScreen = this.container.querySelector('.static-screen');
        
        if (!targetScreen) return;
        
        // Remove all transition classes first
        screens.forEach(screen => {
          screen.classList.remove('active');
        });
        
        // Handle screen 3 (static screen) separately
        if (screenNumber === 3) {
          // Add transition to screens container for smooth sliding out
          if (screensContainer) {
            screensContainer.style.transition = 'transform 2s';
            screensContainer.style.transform = 'translateX(-100%)'; // Move out of view
          }
          
          // Wait for the transform to complete before showing screen 3
          setTimeout(() => {
            // Show the static screen
            if (staticScreen) {
              staticScreen.classList.add('active');
            }
            
            // Update active states
            if (currentActiveScreen) {
              currentActiveScreen.classList.remove('active');
            }
            targetScreen.classList.add('active');
            
            // Clean up transition after animation
            if (screensContainer) {
              screensContainer.style.transition = '';
            }
          }, 1800); // Wait for 4s transition to complete
          
          return;
        }
        
        // Handle screens 1 and 2 (transforming screens)
        if (screensContainer) {
          // Add transition to screens container for smooth sliding
          screensContainer.style.transition = 'transform 2s';
          
          // Hide static screen if it was active
          if (staticScreen) {
            staticScreen.classList.remove('active');
          }
          
          // Calculate slide amount for screens 1 and 2
          const slideAmount = -(screenNumber - 1) * 50; // 50% per screen
          
          screensContainer.style.transform = `translateX(${slideAmount}%)`;
          
          // Update active states
          if (currentActiveScreen) {
            currentActiveScreen.classList.remove('active');
          }
          targetScreen.classList.add('active');
          
          // Clean up transition after animation
          setTimeout(() => {
            screensContainer.style.transition = '';
          }, 6000);
        }
      }
    
      showQuestion(questionNumber) {
        // Hide all questions
        const questions = this.container.querySelectorAll('.question');
        questions.forEach(q => {
            q.classList.remove('active');
        });
  
        // Show target question
        const targetQuestion = this.container.querySelector(`[data-question="${questionNumber}"]`);
        if (targetQuestion) {
            targetQuestion.classList.add('active');
        }
  
        // Update question counter
        const currentQuestionSpan = this.container.querySelector('.current-question');
        if (currentQuestionSpan) {
            currentQuestionSpan.textContent = questionNumber;
        }
  
        // Update progress indicator
        this.updateProgressIndicator();
  
        this.currentQuestion = questionNumber;
        
        // Update navigation state
        this.updateNavigationState();
        
        // Scroll to top of screen-3 container when showing a new question
        if (questionNumber > 1) {
            const screen3 = this.container.querySelector('.screen-3');
            if (screen3) {
                screen3.scrollTo({
                    top: 0,
                    behavior: 'smooth'
                });
            }
        }
    }
  
    updateProgressIndicator() {
        // Update progress bar or indicator to show answered questions
        const progressBar = this.container.querySelector('.progress-bar');
        if (progressBar) {
            const answeredCount = this.scores.filter(score => score !== undefined && score !== null && score > 0).length;
            const progressPercentage = (answeredCount / this.totalQuestions) * 100;
            progressBar.style.width = progressPercentage + '%';
        }
    }
    
    handleAnswerSelection(selectedOption) {
        if (!selectedOption) return;
  
        // Prevent rapid clicking while processing
        if (this.isProcessingAnswer) {
            return;
        }
  
        this.isProcessingAnswer = true;
  
        // Remove previous selection first
        const allOptions = selectedOption.parentElement.querySelectorAll('.answer-option');
        allOptions.forEach(option => {
            option.classList.remove('selected');
        });
    
        // Mark current selection
        selectedOption.classList.add('selected');
        
        // Trigger firecrackers blast effect for answer selection
        this.triggerFirecrackersBlast(selectedOption);
    
        // Get the score value
        const scoreElement = selectedOption.querySelector('.option-score');
        let score = 0;
        
        if (scoreElement) {
        score = parseFloat(scoreElement.textContent);
        } else {
        // Assign points based on position: 1st=1, 2nd=2, 3rd=3 (reversed scoring)
        const optionIndex = Array.from(allOptions).indexOf(selectedOption);
        
        // More robust scoring logic
        if (optionIndex === 0) {
            score = 1; // First option
        } else if (optionIndex === 1) {
            score = 2; // Second option
        } else if (optionIndex === 2) {
            score = 3; // Third option
        } else {
            score = 2; // Default fallback
        }
        
  
        }
    
        // Store the score for the current question
        this.scores[this.currentQuestion - 1] = score;
        
        // Update navigation state to enable right arrow since question is now answered
        this.updateNavigationState();
  
        // Disable all options temporarily to prevent rapid clicking
        allOptions.forEach(option => {
            option.style.pointerEvents = 'none';
        });
  
        // Move to next question after a short delay
        setTimeout(() => {
            // Re-enable options
            allOptions.forEach(option => {
                option.style.pointerEvents = 'auto';
            });
            
            // Reset processing flag
            this.isProcessingAnswer = false;
            
            if (this.currentQuestion < this.totalQuestions) {
                this.showQuestion(this.currentQuestion + 1);
            } else {
                // Validate all questions are answered before showing contact form
                if (this.validateAllQuestionsAnswered()) {
                    this.showContactForm();
                } else {
                    // If some questions are missing, go back to the first unanswered question
                    this.goToFirstUnansweredQuestion();
                }
            }
        }, 1200);
    }
    
      showContactForm() {
        // Hide question container
        const questionContainer = this.container.querySelector('.screen-3-content-inner');
        if (questionContainer) {
            questionContainer.style.display = 'none';
        }
  
        // Show contact form
        const contactFormBlock = this.container.querySelector('.contact-form-block');
        if (contactFormBlock) {
            contactFormBlock.style.display = 'block';
        }
        
        // Use a small delay to ensure the form is fully visible before binding events
        setTimeout(() => {
            this.bindContactFormEvents();
        }, 100);
    }
    
    bindContactFormEvents() {
        const contactForm = this.container.querySelector('#contactForm');
        if (contactForm) {

            // Remove any existing event listeners to prevent duplicates
            contactForm.removeEventListener('submit', this.handleContactFormSubmission);
            contactForm.addEventListener('submit', (e) => {

                // Prevent form submission to avoid page reload
                e.preventDefault();
                e.stopPropagation();
                this.handleContactFormSubmission();
                return false;
            });
            
            // Also add a more aggressive prevention
            contactForm.addEventListener('submit', (e) => {

                e.preventDefault();
                e.stopPropagation();
                e.stopImmediatePropagation();
                return false;
            }, true);
        }
        
        // Also bind click event to the button as backup
        const submitButton = this.container.querySelector('.get-result-btn');
        if (submitButton) {

            submitButton.removeEventListener('click', this.handleContactFormSubmission);
            submitButton.addEventListener('click', (e) => {

                // Prevent form submission to avoid page reload
                e.preventDefault();
                e.stopPropagation();
                this.handleContactFormSubmission();
                return false;
            });
        }
    }
    
    handleContactFormSubmission() {
        // Check rate limiting
        const now = Date.now();
        if (now - this.lastFormSubmission < this.submissionCooldown) {

            const remainingTime = Math.ceil((this.submissionCooldown - (now - this.lastFormSubmission)) / 1000);
            
            // Show visual feedback on button
            const submitButton = this.container.querySelector('.get-result-btn');
            if (submitButton) {
                const originalText = submitButton.textContent;
                submitButton.textContent = `Wait ${remainingTime}s...`;
                submitButton.disabled = true;
                
                // Re-enable button after cooldown
                setTimeout(() => {
                    submitButton.textContent = originalText;
                    submitButton.disabled = false;
                }, (this.submissionCooldown - (now - this.lastFormSubmission)));
            }
        
            return;
        }
        
        // Debug: Check what elements are available
        
        const fullNameInput = this.container.querySelector('#fullName');
        const emailInput = this.container.querySelector('#emailAddress');
        
        if (!fullNameInput || !emailInput) {

            return;
        }
        
        const fullName = fullNameInput.value.trim();
        const emailAddress = emailInput.value.trim();
        
        // Clear previous validation states
        this.clearValidationStates();
        
        // Basic validation
        let isValid = true;
        
        if (!fullName) {
            this.showFieldError(fullNameInput, 'Full name is required');
            isValid = false;
        }
        
        if (!emailAddress) {
            this.showFieldError(emailInput, 'Email address is required');
            isValid = false;
        } else if (!this.isValidEmail(emailAddress)) {
            this.showFieldError(emailInput, 'Please enter a valid email address');
            isValid = false;
        }
        
        if (!isValid) {

            return;
        }
        
        // Update last submission time
        this.lastFormSubmission = now;
        
        // Calculate and set the score before form submission
        this.calculateAndSetScore();
        
        // Populate the message field with score results
        const messageField = this.container.querySelector('#messageBody');
        if (messageField) {
            const scoreField = this.container.querySelector('#fitCheckScore');
            const scoreValue = scoreField ? scoreField.value : 'Score not available';
            messageField.value = `Score: ${scoreValue}`;
        }
        
        // Show loading state on button
        const submitButton = this.container.querySelector('.get-result-btn');
        let originalText = '';
        if (submitButton) {
            originalText = submitButton.textContent;
            submitButton.textContent = 'Submitting...';
            submitButton.disabled = true;
        }
        
        // Submit form data via AJAX to prevent page redirect
        this.submitFormViaAJAX(fullName, emailAddress, () => {

            // Reset button state
            if (submitButton && originalText) {
                submitButton.textContent = originalText;
                submitButton.disabled = false;
            }
            
            // Hide contact form
            const contactFormBlock = this.container.querySelector('.contact-form-block');
            if (contactFormBlock) {
                contactFormBlock.style.display = 'none';
            }
            
            // Show results
            this.showResults();
        });
    }
    
    submitFormViaAJAX(name, email, callback) {
        // Get the score value
        const scoreField = this.container.querySelector('#fitCheckScore');
        const scoreValue = scoreField ? scoreField.value : 'Score not available';
        
        // Show results to user immediately
        callback();
        
        // Submit the form to Shopify's contact endpoint using a hidden iframe
        const form = this.container.querySelector('#contactForm');
        if (form) {
            // Create a hidden iframe to submit the form
            const iframe = document.createElement('iframe');
            iframe.style.display = 'none';
            iframe.name = 'contact-form-submit';
            document.body.appendChild(iframe);
            
            // Set form target to the iframe
            form.target = 'contact-form-submit';
            
            // Submit the form
            form.submit();
            
            // Clean up the iframe after a delay
            setTimeout(() => {
                if (iframe.parentNode) {
                    iframe.parentNode.removeChild(iframe);
                }
            }, 5000);
        } else {
            // Contact form not found - handle silently
        }
    }
    
    clearValidationStates() {
        const inputs = this.container.querySelectorAll('#contactForm input, #contactForm textarea');
        inputs.forEach(input => {
            input.classList.remove('error');
            const errorMessage = input.parentNode.querySelector('.field-error');
            if (errorMessage) {
                errorMessage.remove();
            }
        });
    }
    
    showFieldError(input, message) {
        input.classList.add('error');
        const errorDiv = document.createElement('div');
        errorDiv.className = 'field-error';
        errorDiv.textContent = message;
        input.parentNode.appendChild(errorDiv);
    }
    
    isValidEmail(email) {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailRegex.test(email);
    }
    
    calculateAndSetScore() {
        // Ensure all questions have scores (fill missing scores with 0)
        for (let i = 0; i < this.totalQuestions; i++) {
            if (this.scores[i] === undefined || this.scores[i] === null) {
                this.scores[i] = 0;
            }
        }
        
        // Calculate total score
        const totalScore = this.scores.reduce((sum, score) => sum + score, 0);
        const maxScore = this.totalQuestions * 3; // Maximum score is 21 (7 questions × 3 points each)
        
        // Since the display shows /10, we need to normalize the score to 10
        const normalizedScore = Math.round((totalScore / 21) * 10);
        
        // Set the score in the hidden field
        const scoreField = this.container.querySelector('#fitCheckScore');
        if (scoreField) {
            scoreField.value = `${normalizedScore}/10 (Raw Score: ${totalScore}/${maxScore})`;
        }
        
        return normalizedScore;
    }
    
    showResults() {
        // Show results section
        const resultsSection = this.container.querySelector('.results-section');
        if (resultsSection) {
            resultsSection.style.display = 'flex';
        }
  
        // Ensure all questions have scores (fill missing scores with 0)
        for (let i = 0; i < this.totalQuestions; i++) {
            if (this.scores[i] === undefined || this.scores[i] === null) {
                this.scores[i] = 0;
            }
        }
  
        // Calculate total score
        const totalScore = this.scores.reduce((sum, score) => sum + score, 0);
        const maxScore = this.totalQuestions * 3; // Maximum score is 21 (7 questions × 3 points each), but now first option = 1 point, last option = 3 points
        
        // Since the display shows /10, we need to normalize the score to 10
        const normalizedScore = Math.round((totalScore / 21) * 10);
        
        // Trigger score-display animation
        const scoreDisplay = this.container.querySelector('.score-display');
        if (scoreDisplay) {
            // Reset animation by removing and re-adding the element
            const scoreDisplayClone = scoreDisplay.cloneNode(true);
            scoreDisplay.parentNode.replaceChild(scoreDisplayClone, scoreDisplay);
        }
  
        // Update score display
        const scoreNumber = this.container.querySelector('.score-number');
        if (scoreNumber) {
            // Animate the score counting up with normalized score
            this.animateScore(scoreNumber, 0, normalizedScore);
        }
  
        // Show appropriate conditional section based on raw score (0-21 scale)
        this.showConditionalSection(totalScore);
  
        // Update interpretation text
        const interpretationText = this.container.querySelector('.interpretation-text');
        if (interpretationText) {
            interpretationText.textContent = this.getScoreInterpretation(totalScore, maxScore);
        }
        
        // Trigger confetti animation when results section becomes visible
        this.triggerConfettiAnimation(resultsSection);
    }
    
    triggerConfettiAnimation(resultsSection) {
        // Create intersection observer to detect when results section is visible
        const observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    // Add visible class to trigger confetti animation
                    resultsSection.classList.add('visible');
                    
                    // Apply mix-blend-mode: difference effect for 3 seconds
                    resultsSection.style.mixBlendMode = 'difference';
                    setTimeout(() => {
                        resultsSection.style.mixBlendMode = '';
                    }, 3000);
                    
                    // Disconnect observer after triggering animation
                    observer.disconnect();
                }
            });
        }, { threshold: 0.5 }); // Trigger when 50% of the section is visible
        
        // Start observing the results section
        observer.observe(resultsSection);
    }
    
    animateScore(element, start, end) {
        const duration = 1500;
        const startTime = performance.now();
        
        const animate = (currentTime) => {
        const elapsed = currentTime - startTime;
        const progress = Math.min(elapsed / duration, 1);
        
        // Easing function
        const easeOutQuart = 1 - Math.pow(1 - progress, 4);
        const current = Math.round(start + (end - start) * easeOutQuart);
        
        element.textContent = current;
        
        if (progress < 1) {
            requestAnimationFrame(animate);
        }
        };
        
        requestAnimationFrame(animate);
    }
    
    showConditionalSection(totalScore) {
        // Get the score range data from the hidden input
        const scoreRangeDataInput = this.container.querySelector('#scoreRangeData');
        if (!scoreRangeDataInput) {

            return;
        }
        
        let scoreRangeData;
        try {
            scoreRangeData = JSON.parse(scoreRangeDataInput.value);
        } catch (error) {

            return;
        }
        
        // Clear any existing dynamic score sections
        const dynamicContainer = this.container.querySelector('#dynamic-score-sections');
        if (dynamicContainer) {
            dynamicContainer.innerHTML = '';
        }
        
        // Find the appropriate score range for the current score
        let targetScoreRange = null;
        for (const scoreRange of scoreRangeData) {
            const minScore = parseInt(scoreRange.min_score) || 0;
            const maxScore = parseInt(scoreRange.max_score) || 21;
            
            if (totalScore >= minScore && totalScore <= maxScore) {
                targetScoreRange = scoreRange;
                break;
            }
        }
        
        // Create and show the target score section dynamically
        if (targetScoreRange && dynamicContainer) {
            
            const scoreSection = document.createElement('div');
            scoreSection.className = `score-section score-range-${targetScoreRange.id}`;
            scoreSection.setAttribute('data-min-score', targetScoreRange.min_score);
            scoreSection.setAttribute('data-max-score', targetScoreRange.max_score);
            
            // Create the HTML content for the score section
            let sectionHTML = `
                <h2 class="score-title h1">${targetScoreRange.title}</h2>
                <h3 class="score-sub-title">${targetScoreRange.description}</h3>
            `;
            
            // Add CTA button if available
            if (targetScoreRange.cta_text && targetScoreRange.cta_url) {
                const buttonClass = targetScoreRange.cta_style || 'primary';
                sectionHTML += `
                    <a href="${targetScoreRange.cta_url}" class="score-button ${buttonClass}">
                        ${targetScoreRange.cta_text}
                    </a>
                `;
            }
            
            scoreSection.innerHTML = sectionHTML;
            
            // Add fade-in animation
            scoreSection.style.opacity = '0';
            scoreSection.style.transform = 'translateY(20px)';
            scoreSection.style.transition = 'opacity 0.6s ease, transform 0.6s ease';
            
            // Append to the dynamic container
            dynamicContainer.appendChild(scoreSection);
            
            // Trigger animation
            setTimeout(() => {
                scoreSection.style.opacity = '1';
                scoreSection.style.transform = 'translateY(0)';
            }, 100);
            
        }
    }
  
    getScoreInterpretation(score) {
        // For 7-21 point scale converted to 10-point display: 7-11=Excellent, 12-16=Good, 17-20=Moderate, 21=Needs Improvement
        if (score <= 11) {
            return "Excellent! Your platform is performing well and meeting most of your business needs. Consider minor optimizations for peak performance.";
        } else if (score <= 16) {
            return "Good performance with room for improvement. Your platform handles most situations well but may struggle during peak times.";
        } else if (score <= 20) {
            return "Moderate performance issues detected. Your platform may be limiting your business growth and customer experience.";
        } else {
            return "Significant platform limitations identified. It's likely time to consider upgrading to a more robust e-commerce solution.";
        }
    }
    
    triggerFirecrackersBlast(selectedOption) {
        // Create firecrackers container if it doesn't exist
        let firecrackersContainer = this.container.querySelector('.firecrackers-container');
        if (!firecrackersContainer) {
            firecrackersContainer = document.createElement('div');
            firecrackersContainer.className = 'firecrackers-container';
            this.container.appendChild(firecrackersContainer);
        }
        
        // Get the position of the selected option
        const rect = selectedOption.getBoundingClientRect();
        const containerRect = this.container.getBoundingClientRect();
        
        // Calculate relative position within the container
        const centerX = rect.left - containerRect.left + rect.width / 2;
        const centerY = rect.top - containerRect.top + rect.height / 2;
        
        // Determine blast effect based on which answer option was selected
        const selectedOptionIndex = this.getSelectedOptionIndex(selectedOption);
        
        if (selectedOptionIndex === 0) {
            // First answer option - Dollar blast
            this.createDollarBlast(firecrackersContainer, centerX, centerY);
        } else if (selectedOptionIndex === 1) {
            // Second answer option - Graph icons blast
            this.createGraphIconsBlast(firecrackersContainer, centerX, centerY);
        } else if (selectedOptionIndex === 2) {
            // Third answer option - Shining icons blast
            this.createShiningIconBlast(firecrackersContainer, centerX, centerY);
        } else {
            // Fallback - Default firecracker effect
            this.createDefaultFirecrackerBlast(firecrackersContainer, centerX, centerY);
        }
        
        // Clean up elements after animation
        setTimeout(() => {
            if (firecrackersContainer.parentNode) {
                firecrackersContainer.remove();
            }
        }, 1200);
    }
    
    createDollarBlast(container, centerX, centerY) {
        // Create dollar sign blast effect
        for (let i = 0; i < 14; i++) {
            const dollarIcon = document.createElement('div');
            dollarIcon.innerHTML = `
                <svg width="15" height="28" viewBox="0 0 17 30" fill="none" xmlns="http://www.w3.org/2000/svg" style="opacity: 0.5">
                    <path d="M7.12891 25.9541L6.91016 25.9268C5.82139 25.7922 4.76008 25.4835 3.76562 25.0117L3.76367 25.0107L3.71289 24.9873C2.7414 24.4751 1.90299 23.7337 1.26758 22.8252L0.34375 21.4805L2.93652 19.5938L3.85742 20.9111V20.9121C4.14904 21.3343 4.52364 21.6901 4.95703 21.9561L5.14648 22.0645L5.15625 22.0693C6.04344 22.4923 7.0059 22.7239 7.98242 22.751L8.40137 22.75H8.5L8.88574 22.7529C9.78446 22.738 10.6743 22.5628 11.5156 22.2354C12.1636 22.0008 12.7298 21.5795 13.1445 21.0225L13.1494 21.0166C13.4347 20.6066 13.5804 20.1135 13.5664 19.6123H13.5674V19.5283H13.5664C13.5786 19.1226 13.4889 18.72 13.3047 18.3594L13.2998 18.3486L13.293 18.3389L13.1396 18.125C12.9759 17.9212 12.7802 17.7455 12.5605 17.6035H12.5615C12.0769 17.2845 11.5495 17.0375 10.9961 16.8701L10.9951 16.8691L10.2715 16.666C10.0127 16.5964 9.73381 16.5246 9.42871 16.4492L9.39941 16.4424H9.35254C8.88869 16.3126 8.3683 16.1906 7.57715 16.0166H7.57422C6.4914 15.791 5.42707 15.481 4.39062 15.0898H4.3916C3.50511 14.751 2.70607 14.2141 2.05176 13.5205L1.78027 13.2139L1.72754 13.1436L1.72656 13.1416L1.59082 12.9561C0.934847 12.0134 0.61196 10.868 0.681641 9.70898H0.682617V9.70312C0.723478 8.57736 1.12344 7.49624 1.82129 6.62402L1.87207 6.5625L1.87109 6.56152C2.64482 5.64885 3.64652 4.96648 4.76855 4.58594C5.46392 4.35288 6.18003 4.18983 6.90625 4.09668L7.125 4.06836V0.25H10.3057V4.12598L10.5156 4.16113C10.8832 4.22192 11.2474 4.30264 11.6064 4.40332C12.4435 4.63884 13.2343 5.0207 13.9434 5.53223L13.9453 5.5332C14.4648 5.90328 14.9202 6.35826 15.2939 6.87891L15.4492 7.10645L16.333 8.46582L13.6768 10.2578L12.7998 8.90625L12.6543 8.7041C12.5007 8.51071 12.3205 8.34016 12.1191 8.19727H12.1201C11.7076 7.89772 11.2464 7.67411 10.7578 7.53613L10.7559 7.53516L10.4941 7.46875C9.88113 7.32259 9.25329 7.24893 8.62305 7.25H8.57129C7.73881 7.22551 6.90782 7.33123 6.1084 7.56348L5.76855 7.6709C5.19107 7.86591 4.67642 8.21563 4.27832 8.68262H4.27734L4.27246 8.69043C4.04071 8.98359 3.89922 9.33918 3.86523 9.71289L3.86426 9.72461V9.90918C3.84685 10.3593 3.9949 10.8004 4.28027 11.1465L4.2832 11.1504C4.62457 11.5467 5.05723 11.852 5.54297 12.0371H5.54395C6.43624 12.3762 7.35319 12.6436 8.28613 12.8389V12.8398C9.16233 13.0268 9.72746 13.1613 10.2451 13.3047L10.248 13.3057C10.9054 13.4789 11.4547 13.6283 11.9385 13.7725H11.9395C12.6618 13.9854 13.3556 14.2873 14.0059 14.6709L14.2822 14.8408C14.9984 15.3121 15.6006 15.9433 16.042 16.6875L16.0693 16.7344C16.5722 17.7065 16.8037 18.8009 16.7393 19.8984C16.6746 20.9998 16.3131 22.0609 15.6963 22.9668C14.9181 24.0183 13.8609 24.8199 12.6494 25.2754L12.6465 25.2764C11.9602 25.5446 11.2477 25.7384 10.5215 25.8535L10.3105 25.8867V29.75H7.12891V25.9541Z" stroke="#07182E" stroke-width="0.5"/>
                </svg>
            `;
            dollarIcon.className = 'dollar-blast-icon';
            
            // Calculate final position directly (no center positioning)
            const angle = (Math.PI * 2 * i) / 8 + (Math.random() - 0.5) * 0.6;
            const distance = 80 + Math.random() * 120;
            const finalX = centerX + Math.cos(angle) * distance;
            const finalY = centerY + Math.sin(angle) * distance;
            
            // Position icon directly at final blast position
            dollarIcon.style.left = finalX + 'px';
            dollarIcon.style.top = finalY + 'px';
            dollarIcon.style.position = 'absolute';
            dollarIcon.style.pointerEvents = 'none';
            dollarIcon.style.zIndex = '1000';
            
            // Set CSS custom properties for potential future animations
            dollarIcon.style.setProperty('--x', '0px');
            dollarIcon.style.setProperty('--y', '0px');
            dollarIcon.style.animation = 'dollar-blast 1.4s ease-out forwards';
            dollarIcon.style.animationDelay = (Math.random() * 0.3) + 's';
            
            container.appendChild(dollarIcon);
        }
    }
    
    createGraphIconsBlast(container, centerX, centerY) {
        // Create graph icons blast effect
        for (let i = 0; i < 14; i++) {
            const graphIcon = document.createElement('div');
            graphIcon.innerHTML = `
                <svg width="22" height="22" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" style="opacity: 0.4">
                    <path d="M16.1229 13.5743C16.1914 13.4694 16.1834 13.3302 16.1007 13.2354L15.6089 12.6625C15.9274 12.1018 16.1753 11.5047 16.3487 10.8834L17.0844 10.8572C17.2134 10.8531 17.3242 10.7603 17.3504 10.6333C17.4814 10.0261 17.548 9.40078 17.548 8.77744C17.548 8.17027 17.4855 7.56108 17.3605 6.97007C17.3343 6.84702 17.2315 6.75625 17.1045 6.74616L16.3507 6.68968C16.1794 6.06841 15.9335 5.4713 15.615 4.90854L16.1169 4.36994C16.2056 4.27514 16.2177 4.13192 16.1471 4.02299C15.484 2.99424 14.5911 2.09659 13.5651 1.42492C13.4603 1.35634 13.3212 1.3644 13.2265 1.44711L12.654 1.93929C12.0937 1.62058 11.4971 1.37245 10.8763 1.19899L10.8501 0.462719C10.846 0.333621 10.7533 0.222679 10.6263 0.196457C9.42908 -0.0617393 8.16529 -0.0657724 6.96596 0.186371C6.84301 0.212594 6.75231 0.315469 6.74223 0.442548L6.68579 1.19695C6.06499 1.3684 5.46835 1.6145 4.90803 1.93322L4.36783 1.43094C4.27309 1.34219 4.12998 1.33009 4.02114 1.40069C2.99317 2.06435 2.09621 2.95792 1.42505 3.98466C1.35652 4.08955 1.36458 4.22874 1.44722 4.32355L1.93903 4.89643C1.62056 5.45718 1.37262 6.05429 1.1993 6.67556L0.463589 6.70178C0.334589 6.70582 0.223733 6.79861 0.197531 6.92569C0.0665138 7.53286 0 8.15816 0 8.7815C0 9.38867 0.0624829 9.99786 0.187452 10.5889C0.213655 10.7119 0.316452 10.8027 0.443434 10.8128L1.19725 10.8693C1.36858 11.4905 1.61449 12.0876 1.93296 12.6484L1.43107 13.189C1.34238 13.2838 1.33029 13.427 1.40084 13.5359C2.064 14.5647 2.95688 15.4623 3.98284 16.134C4.08765 16.2026 4.22673 16.1945 4.32146 16.1118L4.89391 15.6196C5.45423 15.9384 6.05088 16.1865 6.67168 16.3599L6.69788 17.0962C6.70191 17.2253 6.79463 17.3363 6.92161 17.3625C7.52832 17.4936 8.15314 17.5602 8.776 17.5602C9.38271 17.5602 9.99144 17.4976 10.582 17.3726C10.7049 17.3463 10.7956 17.2415 10.8057 17.1164L10.8622 16.362C11.483 16.1905 12.0796 15.9444 12.6399 15.6257L13.1801 16.128C13.2749 16.2168 13.418 16.2288 13.5268 16.1583C14.5568 15.4926 15.4538 14.601 16.1229 13.5743ZM13.4039 15.5612L12.8738 15.067C12.7811 14.9803 12.644 14.9661 12.5352 15.0307C11.9103 15.4079 11.2351 15.6883 10.5296 15.8618C10.4107 15.892 10.324 15.9929 10.316 16.1159L10.2595 16.8562C9.27387 17.0358 8.24595 17.0337 7.25828 16.8502L7.23208 16.126C7.22805 15.999 7.13936 15.8921 7.01842 15.8618C6.31094 15.6863 5.63772 15.4059 5.0129 15.0287C4.90809 14.9662 4.77506 14.9763 4.68234 15.0569L4.12001 15.5411C3.2956 14.9702 2.56799 14.24 2.00158 13.4109L2.49541 12.8804C2.58208 12.7877 2.59618 12.6505 2.52967 12.5416C2.15275 11.9163 1.8726 11.2405 1.69922 10.5345C1.66899 10.4155 1.56821 10.3288 1.44526 10.3207L0.705521 10.2642C0.616831 9.77605 0.572493 9.27779 0.572493 8.77957C0.572493 8.26923 0.620865 7.75887 0.713585 7.25864L1.43717 7.23242C1.56415 7.22838 1.67098 7.13963 1.70122 7.0186C1.87657 6.31058 2.15674 5.63684 2.53367 5.01154C2.59616 4.90665 2.58608 4.77351 2.50546 4.68073L2.02171 4.11796C2.59214 3.29292 3.32176 2.56476 4.1502 1.99791L4.68028 2.49212C4.773 2.57885 4.91006 2.59297 5.0189 2.52842C5.64373 2.15121 6.31896 1.87085 7.02443 1.69734C7.14336 1.66709 7.23002 1.56623 7.23808 1.44318L7.29453 0.702878C8.2822 0.523349 9.31011 0.525368 10.2958 0.70893L10.322 1.43307C10.326 1.56015 10.4147 1.66706 10.5376 1.69732C11.2431 1.87281 11.9184 2.15319 12.5432 2.53041C12.648 2.59294 12.781 2.58286 12.8737 2.50217L13.4361 2.01805C14.2605 2.58893 14.9881 3.3191 15.5545 4.14817L15.0607 4.67866C14.974 4.77145 14.9599 4.90862 15.0264 5.01755C15.4033 5.64285 15.6835 6.3186 15.8569 7.02461C15.8871 7.14362 15.9879 7.23036 16.1108 7.23843L16.8506 7.29491C16.9392 7.78306 16.9836 8.28132 16.9836 8.77954C16.9836 9.28988 16.9352 9.80024 16.8425 10.3005L16.1189 10.3267C15.9919 10.3307 15.8851 10.4195 15.8549 10.5405C15.6795 11.2485 15.3993 11.9223 15.0224 12.5476C14.9599 12.6525 14.97 12.7856 15.0506 12.8784L15.5344 13.4411C14.9619 14.2662 14.2323 14.9923 13.4039 15.5612ZM8.77598 3.17191C5.68603 3.17191 3.17483 5.68731 3.17483 8.77942C3.17483 11.8715 5.6883 14.3849 8.77598 14.3849C11.8659 14.3849 14.3771 11.8695 14.3771 8.77942C14.3791 5.6871 11.8657 3.17191 8.77598 3.17191ZM8.77598 13.8184C5.99847 13.8184 3.73897 11.5571 3.73897 8.7775C3.73897 5.99787 5.99847 3.73663 8.77598 3.73663C11.5535 3.73663 13.813 5.99787 13.813 8.7775C13.813 11.5571 11.5535 13.8184 8.77598 13.8184Z" fill="#07182E"/>
                </svg>
            `;
            graphIcon.className = 'graph-blast-icon';
            
            // Calculate final position directly (no center positioning)
            const angle = (Math.PI * 2 * i) / 6 + (Math.random() - 0.5) * 0.5;
            const distance = 70 + Math.random() * 100;
            const finalX = centerX + Math.cos(angle) * distance;
            const finalY = centerY + Math.sin(angle) * distance;
            
            // Position icon directly at final blast position
            graphIcon.style.left = finalX + 'px';
            graphIcon.style.top = finalY + 'px';
            graphIcon.style.position = 'absolute';
            graphIcon.style.pointerEvents = 'none';
            graphIcon.style.zIndex = '1000';
            
            // Set CSS custom properties for potential future animations
            graphIcon.style.setProperty('--x', '0px');
            graphIcon.style.setProperty('--y', '0px');
            graphIcon.style.animation = 'graph-blast 1.3s ease-out forwards';
            graphIcon.style.animationDelay = (Math.random() * 0.2) + 's';
            
            container.appendChild(graphIcon);
        }
    }
    
    createShiningIconBlast(container, centerX, centerY) {
        // Create shining icon blast effect
        for (let i = 0; i < 14; i++) {
            const shiningIcon = document.createElement('div');
            shiningIcon.innerHTML = `
               <svg width="26" height="26" viewBox="0 0 30 32" fill="none" xmlns="http://www.w3.org/2000/svg" style="opacity: 0.3">
                <path d="M11.9506 18.8334C11.9506 18.6467 11.8112 18.4929 11.6304 18.4929C8.68665 18.4929 6.2955 15.9452 6.2955 12.8209C6.2955 12.6342 6.15606 12.4805 5.9753 12.4805C5.79454 12.4805 5.6551 12.6342 5.6551 12.8209C5.6551 15.9452 3.26395 18.4929 0.325363 18.4929C0.144606 18.4929 0 18.6412 0 18.8334C0 19.0256 0.144606 19.1738 0.325363 19.1738C3.26395 19.1738 5.6551 21.7216 5.6551 24.8458C5.6551 25.0325 5.79971 25.1863 5.98047 25.1863C6.16122 25.1863 6.30066 25.038 6.30066 24.8458C6.30066 21.7216 8.69182 19.1738 11.6356 19.1738C11.8112 19.1738 11.9506 19.0201 11.9506 18.8334ZM5.98047 22.7978C5.38139 20.9419 3.99731 19.4648 2.25171 18.8334C3.99731 18.2019 5.37622 16.7249 5.98047 14.869C6.57438 16.7249 7.95846 18.2019 9.70922 18.8334C7.95846 19.4648 6.57438 20.9419 5.98047 22.7978Z" fill="#07182E"/>
                <path d="M16.9663 27.9038C15.3757 27.9038 14.0846 26.5311 14.0846 24.8399C14.0846 24.6533 13.9451 24.4995 13.7644 24.4995C13.5836 24.4995 13.4493 24.6587 13.4493 24.8454C13.4493 26.5366 12.153 27.9093 10.5624 27.9093C10.3868 27.9093 10.2422 28.0576 10.2422 28.2552C10.2422 28.4364 10.3816 28.5902 10.5624 28.5902C12.153 28.5902 13.4493 29.9684 13.4493 31.6596C13.4493 31.8463 13.5888 32 13.7695 32C13.9503 32 14.0897 31.8518 14.0897 31.6596C14.0897 29.9684 15.3808 28.5902 16.9715 28.5902C17.1471 28.5902 17.2917 28.4419 17.2917 28.2552C17.2814 28.0576 17.1419 27.9038 16.9663 27.9038ZM13.7695 30.0947C13.4132 29.2765 12.7934 28.6176 12.0291 28.2498C12.7934 27.8709 13.4183 27.2175 13.7695 26.3993C14.1155 27.212 14.7353 27.8709 15.5048 28.2498C14.7353 28.6176 14.1155 29.2765 13.7695 30.0947Z" fill="#07182E"/>
                <path d="M29.6719 10.5918C24.3628 10.5918 20.0402 5.996 20.0402 0.345924C20.0402 0.153745 19.8956 0 19.72 0C19.5392 0 19.3946 0.148254 19.3946 0.345924C19.3946 5.996 15.0771 10.5918 9.76286 10.5918C9.58211 10.5918 9.4375 10.7401 9.4375 10.9323C9.4375 11.1245 9.58211 11.2672 9.76286 11.2672C15.0771 11.2672 19.3946 15.8631 19.3946 21.5131C19.3946 21.6998 19.5341 21.8536 19.72 21.8536C19.8904 21.8536 20.0402 21.7053 20.0402 21.5131C20.0402 15.8631 24.3628 11.2672 29.6719 11.2672C29.8527 11.2672 29.9973 11.119 29.9973 10.9268C29.9973 10.7346 29.8527 10.5918 29.6719 10.5918ZM19.72 18.8116C18.7904 14.9571 15.9344 11.9151 12.309 10.9323C15.9344 9.94392 18.7955 6.90748 19.7251 3.04742C20.6547 6.90199 23.5055 9.94392 27.1362 10.9323C23.5055 11.9151 20.6496 14.9571 19.72 18.8116Z" fill="#07182E"/>
            </svg>
            `;
            shiningIcon.className = 'shining-blast-icon';
            // Calculate final position directly (no center positioning)
            const angle = (Math.PI * 2 * i) / 9 + (Math.random() - 0.5) * 0.7;
            const distance = 90 + Math.random() * 130;
            const finalX = centerX + Math.cos(angle) * distance;
            const finalY = centerY + Math.sin(angle) * distance;
            
            // Position icon directly at final blast position
            shiningIcon.style.left = finalX + 'px';
            shiningIcon.style.top = finalY + 'px';
            shiningIcon.style.position = 'absolute';
            shiningIcon.style.pointerEvents = 'none';
            shiningIcon.style.zIndex = '1000';
            
            // Set CSS custom properties for potential future animations
            shiningIcon.style.setProperty('--x', '0px');
            shiningIcon.style.setProperty('--y', '0px');
            shiningIcon.style.animation = 'shining-blast 1.5s ease-out forwards';
            shiningIcon.style.animationDelay = (Math.random() * 0.4) + 's';
            
            container.appendChild(shiningIcon);
        }
    }
    
    getSelectedOptionIndex(selectedOption) {
        // Find the parent container with answer options
        const answerOptionsContainer = selectedOption.closest('.answer-options');
        if (!answerOptionsContainer) return 0;
        
        // Get all answer options in the same container
        const allOptions = answerOptionsContainer.querySelectorAll('.answer-option');
        
        // Find the index of the selected option
        for (let i = 0; i < allOptions.length; i++) {
            if (allOptions[i] === selectedOption) {
                return i; // Return 0 for first, 1 for second, 2 for third
            }
        }
        
        return 0; // Default fallback
    }
    
    createDefaultFirecrackerBlast(container, centerX, centerY) {
        // Create flash effect
        const flash = document.createElement('div');
        flash.className = 'firecracker-flash';
        flash.style.left = centerX + 'px';
        flash.style.top = centerY + 'px';
        container.appendChild(flash);
        
        // Particle color classes for variety
        const particleColors = ['', 'blue', 'green', 'purple', 'orange'];
        
        // Create multiple particles with random directions and colors
        for (let i = 0; i < 20; i++) {
            const particle = document.createElement('div');
            const colorClass = particleColors[Math.floor(Math.random() * particleColors.length)];
            particle.className = `firecracker-particle ${colorClass}`;
            particle.style.left = centerX + 'px';
            particle.style.top = centerY + 'px';
            
            // Random direction and distance with more variation
            const angle = (Math.PI * 2 * i) / 20 + (Math.random() - 0.5) * 0.8;
            const distance = 60 + Math.random() * 120;
            const x = Math.cos(angle) * distance;
            const y = Math.sin(angle) * distance;
            
            particle.style.setProperty('--x', x + 'px');
            particle.style.setProperty('--y', y + 'px');
            
            // Random delay for staggered effect
            particle.style.animationDelay = (Math.random() * 0.2) + 's';
            
            container.appendChild(particle);
        }
        
        // Create spark effects with more variety
        for (let i = 0; i < 12; i++) {
            const spark = document.createElement('div');
            spark.className = 'firecracker-spark';
            spark.style.left = centerX + 'px';
            spark.style.top = centerY + 'px';
            
            // Random direction and distance for sparks
            const angle = (Math.PI * 2 * i) / 12 + (Math.random() - 0.5) * 0.4;
            const distance = 40 + Math.random() * 80;
            const x = Math.cos(angle) * distance;
            const y = Math.sin(angle) * distance;
            
            spark.style.setProperty('--x', x + 'px');
            spark.style.setProperty('--y', y + 'px');
            
            // Random delay for staggered effect
            spark.style.animationDelay = (Math.random() * 0.3) + 's';
            
            container.appendChild(spark);
        }
        
        // Create additional burst particles for more dramatic effect
        setTimeout(() => {
            for (let i = 0; i < 8; i++) {
                const burstParticle = document.createElement('div');
                const colorClass = particleColors[Math.floor(Math.random() * particleColors.length)];
                burstParticle.className = `firecracker-particle ${colorClass}`;
                burstParticle.style.left = centerX + 'px';
                burstParticle.style.top = centerY + 'px';
                
                // Different angle pattern for burst effect
                const angle = (Math.PI * 2 * i) / 8 + Math.random() * 0.5;
                const distance = 80 + Math.random() * 100;
                const x = Math.cos(angle) * distance;
                const y = Math.sin(angle) * distance;
                
                burstParticle.style.setProperty('--x', x + 'px');
                burstParticle.style.setProperty('--y', y + 'px');
                
                container.appendChild(burstParticle);
            }
        }, 100);
    }
  }
    
  // Auto-initialize when DOM is ready
  document.addEventListener('DOMContentLoaded', function() {
    const fitCheckSections = document.querySelectorAll('.animated-fit-check');
    fitCheckSections.forEach(section => {
        new AnimatedFitCheck(section);
    });
  });